import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { ArrowRight } from "lucide-react";

const INDUSTRY_IMG = {
  "Construction": "https://images.unsplash.com/photo-1672748341520-6a839e6c05bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjB3b3JrZXIlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODUyNjU5MjR8MA&ixlib=rb-4.1.0&q=85",
  "Energy": "https://images.unsplash.com/photo-1660330589693-99889d60181e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxlbGVjdHJpY2lhbiUyMGF0JTIwd29ya3xlbnwwfHx8fDE3ODUyNjU5MjR8MA&ixlib=rb-4.1.0&q=85",
  "Advanced Manufacturing": "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHx3ZWxkaW5nJTIwbWFudWZhY3R1cmluZyUyMGZhY3Rvcnl8ZW58MHx8fHwxNzg1MjY1OTI0fDA&ixlib=rb-4.1.0&q=85",
  "Healthcare": "https://images.unsplash.com/photo-1621905252507-b35492cc74b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHw0fHxodmFjJTIwdGVjaG5pY2lhbnxlbnwwfHx8fDE3ODUyNjU5MjR8MA&ixlib=rb-4.1.0&q=85",
};

export default function Industries() {
  const [industries, setIndustries] = useState([]);
  useEffect(() => { api.get("/industries").then((r) => setIndustries(r.data)); }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="text-xs font-mono-alt uppercase text-yellow-500 tracking-widest mb-2">Industries</div>
      <h1 className="font-display text-5xl md:text-6xl uppercase leading-none mb-10">
        Pick your <span className="text-yellow-500">trade</span>
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
        {industries.map((ind, i) => (
          <Link
            key={ind.name}
            to={`/jobs?industry=${encodeURIComponent(ind.name)}`}
            data-testid={`industries-${ind.name}`}
            className="group relative overflow-hidden border border-zinc-800 hover:border-yellow-500 bg-zinc-950 aspect-[4/3] transition-all"
            style={{ animation: `fadeUp 0.5s ease ${i * 40}ms both` }}
          >
            {INDUSTRY_IMG[ind.name] && (
              <img src={INDUSTRY_IMG[ind.name]} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30 group-hover:opacity-50 transition-opacity" />
            )}
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-transparent" />
            <div className="relative h-full p-6 flex flex-col justify-between">
              <div className="text-xs font-mono-alt uppercase text-yellow-500 tracking-widest">#{String(i + 1).padStart(2, "0")}</div>
              <div>
                <div className="font-display text-3xl uppercase leading-none group-hover:text-yellow-500 transition">{ind.name}</div>
                <div className="mt-2 flex items-center justify-between text-sm">
                  <span className="text-zinc-400">{ind.count} apprenticeships</span>
                  <ArrowRight size={16} className="text-yellow-500 group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
